import { render, staticRenderFns } from "./createFaqCategory.vue?vue&type=template&id=ce17ce62&"
import script from "./createFaqCategory.vue?vue&type=script&lang=js&"
export * from "./createFaqCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports